import React from "react";

/**
 * Icône de techno, quelle que soit son origine.
 *
 * Font Awesome ne couvre pas toute la stack (ni TypeScript, ni Next.js, ni
 * PostgreSQL…). Les manquantes viennent de Simple Icons et sont appliquées en
 * masque CSS plutôt qu'en <img> : le masque prend la couleur de `currentColor`,
 * donc l'icône reste neutre puis se colore au survol exactement comme les
 * icônes Font Awesome voisines. Un <img> aurait gardé sa couleur de marque en
 * permanence et cassé l'effet.
 */
export default function BrandIcon({ competence, size }) {
	const { _class, svg } = competence;

	if (svg) {
		return (
			<span
				className="brand-icon"
				style={{
					width: size,
					height: size,
					WebkitMaskImage: `url(${svg})`,
					maskImage: `url(${svg})`,
				}}
			/>
		);
	}

	return <i className={`fab fa-${_class}`} style={{ fontSize: size }}> </i>;
}
